// for add employee

export const RESET_ADD_USER = "reset_add_user";
export const ADD_USER = "add_user";
export const ADD_USER_SUCCESS = "add_user_success";
export const ADD_USER_FAILURE = "add_user_failure";
